import React from "react";
import TugHistory from "../../common/TugHistory";
const SideHistory = () => <TugHistory reportType="side" />;
export default SideHistory;
